import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-machine-list',
  templateUrl: './machine-list.component.html',
  styleUrls: ['./machine-list.component.scss'],
})
export class MachineListComponent implements OnInit {
  @Input() machines: any
  @Output() selectedMachine = new EventEmitter<void>()
  @Output() onReorderMachines = new EventEmitter<void>();
  //activeMachineIndex: number | null = null;
  activeMachineIndex = 0;

  constructor() { }

  ngOnInit() {
  }

  onDrop(event: CdkDragDrop<string[]>) {
    moveItemInArray(this.machines, event.previousIndex, event.currentIndex);
    this.machines.forEach((machine, index) => {
        machine.order_no = index + 1;
    });
    this.selectedMachine.emit(this.machines[this.activeMachineIndex]);
    this.onReorderMachines.emit(this.machines);
  }

  public selectMachine(index, machine) {
    this.activeMachineIndex = index;
    this.selectedMachine.emit(machine);
  }

}